// src/components/Teams.js
import React, { useState } from "react";
import { Tabs, Tab, Box, Paper } from "@mui/material";
import CreateTeam from "./CreateTeam";
import ManageTeam from "./ManageTeam";
import JoinTeam from "./JoinTeam";

const Teams = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ width: "100%", mt: 4 }}>
      <Paper square>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
            <Tab label="Join Teams" />
            <Tab label="Create Team" />
            <Tab label="Manage Teams" />
          
        </Tabs>
      </Paper>
      <Box sx={{ p: 3 }}>
        {currentTab === 0 && <JoinTeam />}
        {currentTab === 1 && <CreateTeam />}
        {currentTab === 2 && <ManageTeam />}
      </Box>
    </Box>
  );
};

export default Teams;